
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `Tryck på ”Öppna i webbläsare…”`,
's182ab2d6c997515f': `Lägg till på hemskärmen för att få en bättre användarupplevelse och enklare åtkomst.`,
's224cbcec014ef6b5': `Tryck på Dela-knappen i verktygsfältet`,
's233af3b7eb5e0364': `Lägg till på startsidan`,
's37a9e8aec5713460': `Mer`,
's4c3161035f3a1413': `Tryck på Meny`,
's4e1e10a6ca408245': `Tryck på "Lägg till på hemskärmen"`,
's6196153c4b0c1ea0': `Installera`,
's633502f7cff4f847': `Öppna din webbläsares meny`,
's681e399d63311fba': `Visa galleri`,
's6d14a4f70ba4e3cf': `Tryck på Meny om det inte finns någon delningsikon`,
's922329d6f6213590': `Lägg till i Dock`,
's9c63a79ffcc2a3a3': `Tryck på "Lägg till på hemskärmen"`,
'sa2d71bfd9525168d': `Tryck på "Lägg till i Dock"`,
'sa5ef80b4bb9b39f8': `Mindre`,
'sb527eca1c1d7e7be': `Öppna menyn i appens webbläsare`,
'sba52286c21552a4e': `Installera den på din enhet för att få en bättre användarupplevelse och enklare åtkomst.`,
'sc16e00a7a8b2fde2': `Tillbaka`,
'scdaf4bbff76674c8': `Lägg till på hemskärmen`,
'sd18a5b85f599ff3c': `Öppna den kopierade länken i Safari`,
'se72fc3a84f9b51c3': `Tryck för att kopiera länken`,
'se740f75b95a51807': `Lägg till i Dock för att få en bättre användarupplevelse och enklare åtkomst.`,
'sfa6c42cdf48d93d2': `Men den här webbläsaren stöder inte den här funktionen. Öppna länken i en extern webbläsare för att fortsätta.`,
'sfb78526365796a41': `Tryck på "Visa mer" i delningsmenyn`,
'sfea652f6580ff086': `Denna webbsajt har app-funktionalitet.`,
    };
  